import { Pipe, PipeTransform } from '@angular/core';
import { AmlRisk } from '@app/core/state/types/aml.types';

@Pipe({
  name: 'amlRiskToTranslationKey',
  standalone: true,
})
export class AmlRiskToTranslationKeyPipe implements PipeTransform {
  private valueToTranslationKey = {
    [AmlRisk.LOW]: 'amlRiskLow',
    [AmlRisk.NORMAL]: 'amlRiskNormal',
    [AmlRisk.HIGH]: 'amlRiskHigh',
  };

  transform(value: AmlRisk | null, translationScope: string): string {
    if (!value) {
      return null;
    }

    return `${translationScope}.${this.valueToTranslationKey[value] ?? value}`;
  }
}
